function LoadingButtonComponent() {
  return (
    <div className="inline-flex justify-center items-center">
      <div className="animate-spin rounded-full h-10 w-10 border-t-2 border-b-2 border-purple-500"></div>
    </div>
  );
}

export default LoadingButtonComponent;